export default __webpack_public_path__ + "static/media/plugged.8da8283e.svg";